// eslint-disable-next-line no-unused-vars
import React from 'react';
import { CounterLabel } from '@weezevent/nacre';

export default function CounterInput({ label, value, onChange = () => {}, ...params }) {
    return (
        <CounterLabel
            label={label}
            value={value}
            style={{ width: '122px' }}
            placeholder={'0'}
            onChange={(e, changedValue) => {
                onChange(changedValue);
            }}
            {...params}
        />
    );
}
